// extracted by mini-css-extract-plugin
export var statItem = "_h9-1";
export var statsRow = "_h9-0";